import * as types from './types'
import { createReducer } from 'app/state/utils'

const initialState: never[] = []

const usersReducer = createReducer(initialState)({
  [types.SET_USERS]: (state: any, payload: any) => {
    return { ...state, users: payload }
  },
  [types.UPDATE_USER]: (state: any, action: any) => {
    const updated = action?.payload
    const existing = state?.users?.payload?.data
    if (!updated?.id || !Array.isArray(existing)) return state
    return {
      ...state,
      users: {
        ...state.users,
        payload: {
          ...state.users.payload,
          data: existing.map((u: any) => (u.id === updated.id ? { ...u, ...updated } : u)),
        },
      },
    }
  },
})

export default usersReducer
